export const hongbao = {
    hb: "Красный конверт",
    dps: "Массовая рассылка",
    xdhb: "Эксклюзивные красные конверты, миллионы бонусов ждут вас!",
    fxhb: "Поделитесь красным конвертом и получите больше наград",
    khb: "Открыть красный конверт Biking",
    kqz: "Открытие...",
    ylq: "Получено",
    hdwks: "Акция ещё не началась",
    hdjxz: "Акция идёт",
    hdyjs: "Акция завершена",
    hddjs: "Обратный отсчёт до акции",
    hdsj: "Время проведения акции",
    zwhd: "Нет активных акций",
    hblsjlxq: "Детали моей истории наград в красных конвертах",
    jxz: "В процессе",
    ygq: "Истекло",
    dks: "Скоро начнётся",
    zwjl: "Нет наград",
    wnmztj: "Вы не выполнили условия акции",
    wxts: "Внимание",
    yhwcrz: "Пользователь прошёл KYC-верификацию и привязал номер телефона",
    yhwcjy: "Пользователь совершил спот-торговлю на сумму ≥100 USDT, или фьючерсную торговлю (без кредитного плеча) на сумму ≥100 USDT, или опционную торговлю на сумму ≥100 USDT, или торговлю GameFi на сумму ≥100 USDT (хотя бы одно условие)",
    djzh: "Аккаунты с риском или ограничением на вывод не могут участвовать в акции",
    hdhbjl: "Получена награда в красном конверте",
    sqbj: "Не повезло",
    dkapp: "Открыть приложение",
    smewm: "Отсканируйте QR-код",
    wchdtj: "Выполните условия акции и получите красный конверт",
    fxhd: "Поделитесь акцией, получите больше красных конвертов",
    jdcz: "Простые действия — зарабатывайте",
    hdhb: "Акционный красный конверт",
    zdqj: "Указанный период",
    wcjye: "Выполните объём торгов по {type} {text} ≥ {amount} USDT",
    yhwfhtj: "За {time} до выпуска красного конверта у пользователя не было подходящих транзакций",
    hbsxq: "За {time} {day} до выпуска красного конверта пользователь {text}",
    bhgg: "без кредитного плеча",
    h: "или",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/ru.js